import type { Ratebook } from '@api/useFreight/types'

// Helper to initialize address info from ratebook
export const initializeAddressInfo = (ratebookAddress?: Ratebook['address_info']) => ({
  address: ratebookAddress?.address ?? '',
  city: ratebookAddress?.city ?? '',
  state: ratebookAddress?.state ?? '',
  postal_code: ratebookAddress?.postal_code ?? '',
})

export function getSelectOptions(options: string[]) {
  if (!options || options.length === 0) {
    return []
  }
  return options.map((option) => ({
    label: option,
    value: option,
  }))
}
